import { render, staticRenderFns } from "./WhyChooseHortense.vue?vue&type=template&id=6005da8e&scoped=true&"
import script from "./WhyChooseHortense.vue?vue&type=script&lang=js&"
export * from "./WhyChooseHortense.vue?vue&type=script&lang=js&"
import style0 from "./WhyChooseHortense.vue?vue&type=style&index=0&id=6005da8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005da8e",
  null
  
)

export default component.exports